import React from 'react';
import { BlockPreviewComponent } from '../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../CurrentBlockProvider';
import { BlockModuleType } from '../../../declarations/models/BlockModuleType';
import { ReferenceType, ReferencesBlockModel } from '../../../declarations/models/blocks/ReferencesBlock';

export const ReferencesBlockPreview: BlockPreviewComponent = () => {
  const { block } = useCurrentBlock();
  const currentBlock = block as ReferencesBlockModel;

  const referenceContent = () => {
    return (
      <ul className='article__references'>
        {currentBlock?.items &&
          currentBlock?.items.map((item, i) => {
            if (item.referenceType === ReferenceType.BOOK) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className='source source--book'>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author}
                    {item?.editor ? ` ${item?.editor}, Ed. ` : ''}
                    {item?.author && !item?.editor && ' ,'}
                  </strong>
                  <em className='source__title'>{item?.title}</em>
                  {item?.issue ? <span> ({item?.issue})</span> : null}.
                  <span className='source__details'>
                    {' '}
                    {item?.place}
                    {item?.place && item?.publisher ? ': ' : ''} {item?.publisher ? `${item?.publisher}` : ''}
                    {item?.date ? <span>, {item?.date}</span> : ''}.
                  </span>
                </li>
              );
            }
            if (item.referenceType === ReferenceType.ARTICLE) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className={`source source--${item.referenceType}`}>
                  {item?.referenceNumber ? <strong>[{item?.referenceNumber}] </strong> : ''}
                  {item?.author && <strong>{item?.author},</strong>}
                  {item.title && <span className='source__title'> «{item?.title.replace('"', '')}»</span>}
                  <em className='source__media'>{item.media && `, ${item?.media}`}</em>
                  <span className='source__details'>
                    {item?.issue ? `, ${item?.issue}` : ''}
                    {item?.page ? `, s. ${item?.page}` : ''}
                    {item?.date ? `, ${item?.date}` : ''}.
                  </span>
                  {item?.doi && (
                    <span>
                      {' '}
                      doi:
                      {item?.doi}
                    </span>
                  )}
                  {item?.url && (
                    <span>
                      {' '}
                      <a href={`${item?.url}`} target='_blank' rel='noopener noreferrer'>
                        {item?.url}
                      </a>
                    </span>
                  )}
                </li>
              );
            }
            if (item.referenceType === ReferenceType.NEWSPAPER) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className={`source source--${item.referenceType}`}>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author},
                  </strong>
                  {item.title && <span className='source__title'> {item?.title}.</span>}
                  <em className='source__title'> {item?.media}.</em>
                  <span className='source__details'>
                    {item?.issue}
                    {item?.page ? `, s. ${item?.page}.` : ''}
                    {item?.date ? ` ${item?.date}.` : ''}
                  </span>
                </li>
              );
            }
            if (item.referenceType === ReferenceType.REPORT) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className={`source source--${item.referenceType}`}>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author},
                  </strong>
                  {item.title && <span> «{item?.title.replace(' i"', '"').replace('"', '')}» </span>}
                  <span className='source__title'>{item?.media}</span>
                  <span className='source__details'>
                    {item?.issue}
                    {item?.page ? `,s. ${item?.page}.` : ''}
                    {item?.reportNumber ? ` ${item?.reportNumber}` : ''}
                    {item?.date ? `, ${item?.date}.` : ''}
                  </span>
                </li>
              );
            }
            if (item.referenceType === ReferenceType.DOCUMENT) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className='source source--document'>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author},
                  </strong>
                  <span className='source__title'> {item?.title}</span>
                  {item?.issue ? <span> {item?.issue}</span> : null}
                  <span className='source__details'>
                    {item?.publisher ? `: ${item?.publisher}` : ''}
                    {item?.url && (
                      <a href={`${item?.url}`} target='_blank' rel='noopener noreferrer'>
                        {item?.url}
                      </a>
                    )}
                    {item?.date ? <span>&nbsp; ({item?.date})</span> : ''}.
                  </span>
                </li>
              );
            }
            if (item.referenceType === ReferenceType.WEBSITE) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className='source source--website'>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author}.
                  </strong>
                  <span className='source__title'> {item?.title}.</span>
                  {item?.media && <em className='source__sitename'> {item?.media}.</em>}
                  <span className='source__details'>
                    {' '}
                    {item?.url && (
                      <a href={`${item?.url}`} target='_blank' rel='noopener noreferrer'>
                        {item?.url}
                      </a>
                    )}
                    {item?.date ? <span>&nbsp; ({item?.date})</span> : ''}.
                  </span>
                </li>
              );
            }

            if (item.referenceType === ReferenceType.OTHER) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`pi-${i}`} className='source source--other'>
                  <strong>
                    {item?.referenceNumber ? `[${item?.referenceNumber}] ` : ''}
                    {item?.author}
                    {item?.date ? <span>{`:${item?.date}`}</span> : ''}
                  </strong>
                  <em className='source__title'> {item?.title}</em>
                  <span className='source__details'>
                    {item?.media}
                    {item?.publisher ? `, ${item?.publisher}` : ''} {item?.place ? `, ${item?.place}` : ''}
                  </span>
                </li>
              );
            }

            return null;
          })}
      </ul>
    );
  };

  return (
    <div className='article__grid'>
      {currentBlock?.module__type !== BlockModuleType.MODULE ? (
        <div className='article__content'>
          {currentBlock?.visibletitle && (
            <div className='article__bodytext'>
              <h2>{currentBlock?.title}</h2>
            </div>
          )}
          <div className='article__bodytext'>
            {currentBlock?.body && <p style={{ whiteSpace: 'pre-line' }}>{currentBlock?.body}</p>}
            {referenceContent()}
          </div>
        </div>
      ) : (
        <div className='module module--content'>
          <div className={`module__grid skin skin-contentbox ${currentBlock?.skin || ''}`}>
            {currentBlock?.state === 'semi' ? (
              <div className='preview__blockmessage'>Tekstboks vil være delvis åpen i portal</div>
            ) : null}
            {currentBlock?.state === 'collapsed' ? (
              <div className='preview__blockmessage'>Tekstboks vil være lukket i portal</div>
            ) : null}
            <div className='module__content'>
              <div className='module__head'>{currentBlock?.visibletitle && <h2>{currentBlock?.title}</h2>}</div>
              <div className='module__body'>
                {currentBlock?.body && <p style={{ whiteSpace: 'pre-line' }}>{currentBlock?.body}</p>}
                {referenceContent()}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferencesBlockPreview;
